export default __webpack_public_path__ + "static/media/Product_img.14e6427d.jpg";